import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  FormFeedback,
  Form,
  Input,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesRoutes,
  resourcesFuelSales,
  getUnitsWithOperators,
  resourcesConfigurationRoute,
  postRouteConfig
} from "../../../helpers/backend_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

const formatter = new Intl.NumberFormat('es-MX', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const PriceModal = ({
  modal,
  setModal,
  price,
  setPrice,
  authUser,
}) => {
  const [priceForm, setPriceForm] = useState(price);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModal({ ...modal, show: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { price: priceForm },
    validationSchema: Yup.object({
      price: Yup.number().nullable(true).required("Requerido"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      await save(values);
      setLoading(false);
    },
  });

  const save = async (values) => {
    const response = await postRouteConfig({14: values.price})
    responseAction(response)
  };

  const responseAction = (response) => {
    setPrice(priceForm)
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          Establecer Precio de Combustible
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <NibbleInput
                md={12}
                label="Precio Unitario:"
                fieldName="price"
                fieldType="number"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default PriceModal;
